<template>
  <div v-if="productData" class="col-12 main-shad advCartRow">
    <div class="d-flex-100 advCartRowMain" v-if="miniCart">
      <div class="d-flex-100 minicartItem">
        <div class="row" v-if="
            'options' in cartProduct &&
            'appliedBundles' in cartProduct.options &&
            cartProduct.options.appliedBundles.length > 0
          ">
          <div class="col-2 p-0 m-0"></div>
          <div class="col-10 p-0 m-0">
            <adv-cart-product-bundle-display
              class="col-12 p-0 m-0"
              :cart-product="cartProduct"
              :product-data="productData"
              style-type="smart"
            />
          </div>
        </div>
        <div class="col-2 minicart-item-thumb">
          <div class="thumbnail_container">
            <div class="thumbnail">
              <img class="img-fluid" :src="imageSrc" :alt="productData.productName"/>
            </div>
          </div>
        </div>
        <div class="d-flex flex-wrap align-content-center col-10 cart_item_info">
          <button v-on:click="removeProductFromCart" :disabled="!onlineStatus" class="action-item rem-minicart-prod pos-abs" v-if="!readOnly">
            <svg xmlns="http://www.w3.org/2000/svg" width="25.67" height="25.67" data-name="Group 16950" class="transXY-50">
              <title>Delete {{ productData.productName }} from cart</title>
              <path fill="#676767" d="M24.993 5.888H9.069a.676.676 0 0 1-.676-.675.676.676 0 0 1 .676-.676h15.924a.676.676 0 0 1 .676.676.676.676 0 0 1-.676.675Z" data-name="Line 346"/>
              <path fill="#676767" d="M5.878 5.888h-5.2A.676.676 0 0 1 0 5.213a.676.676 0 0 1 .676-.676h5.2a.676.676 0 0 1 .676.676.676.676 0 0 1-.674.675Z" data-name="Line 347"/>
              <path fill="#676767" d="M20.063 25.67H5.685a3.382 3.382 0 0 1-3.378-3.378V5.213a.676.676 0 0 1 1.351 0v17.08a2.029 2.029 0 0 0 2.027 2.027h14.378a2.029 2.029 0 0 0 2.026-2.027V5.213a.676.676 0 0 1 1.351 0v17.08a3.381 3.381 0 0 1-3.377 3.377Z" data-name="Path 71539"/>
              <path fill="#676767" d="M17.837 20.648a.676.676 0 0 1-.676-.676v-9.737a.676.676 0 0 1 .676-.676.676.676 0 0 1 .676.676v9.737a.676.676 0 0 1-.676.676Z" data-name="Line 348"/>
              <path fill="#676767" d="M7.911 20.648a.676.676 0 0 1-.676-.676v-9.737a.676.676 0 0 1 .676-.676.676.676 0 0 1 .676.676v9.737a.676.676 0 0 1-.676.676Z" data-name="Line 349"/>
              <path fill="#676767" d="M12.886 20.648a.676.676 0 0 1-.676-.676v-9.737a.676.676 0 0 1 .676-.676.676.676 0 0 1 .676.676v9.737a.676.676 0 0 1-.676.676Z" data-name="Line 350"/>
              <path fill="#676767" d="M16.602 5.888H9.07a.676.676 0 0 1-.676-.676v-.77a4.442 4.442 0 1 1 8.883 0v.771a.676.676 0 0 1-.675.675ZM9.745 4.537h6.181v-.1a3.091 3.091 0 0 0-6.181 0Z" data-name="Path 71540"/>
            </svg>
          </button>
          <div class="col-12 pos-rel cart_item_name">
            {{ productData.productName }}
          </div>
          <div v-if="cartProduct.options" class="product-options-wrapper">
            <div v-for="(option, key) in filteredOptions" :key="key">
              <span>{{ key }} </span>: {{ option }}
            </div>
            <div class="product-prescription-wrapper">
              <div v-for="(option, key) in cartProduct.options.prescription" :key="key">
                <div v-if="option !== 'Null' && key !== 'level'">
                  <span>{{ t(key) }} </span>: {{ option === 'Null' ? t('prescription.null.value') : option }}
                </div>
              </div>
              <a class="prescription-button" v-if="cartProduct.options.prescriptionData" href="/order/cart">
                {{ t('prescription.view') }}
              </a>
            </div>
          </div>

          <div class="d-flex flex-wrap align-items-center col-5 minicart-price">
            <span class="db-100">
              {{ t('price') }}: <span v-html="finalTotalPriceWithSign"></span>
            </span>
          </div>
          <div class="d-flex flex-wrap align-items-center col-7 ml-auto minicart-input-col" v-if="!readOnly">
            <adv-cart-input-spinner
              class="quantitySpinner"
              :product-code-id="cartProduct.productCodeId"
              :quantity="cartProduct.quantity"
              v-on:quantity-changed="updateProductQuantity">
            </adv-cart-input-spinner>
          </div>
          <AdvCartProductCustomizationDisplayValues :product="cartProduct" />
          <div class="col-12 minicart-quantity" v-if="readOnly">
            <span>
              {{ t('quantity') }}: {{ cartProduct.quantity }}
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="d-flex-100" v-if="!miniCart">
      <div class="d-flex-100 pos-rel minicart-item-row">
        <div class="col-12 text-center helpCartMsg m-3" v-show="cartError && !readOnly">
          <span><em class="ti-info-alt"></em> {{ cartError }}</span>
        </div>
        <div class="col-2 minicart-item-thumb">
          <div class="thumbnail_container">
            <div class="thumbnail">
              <img :src="imageSrc" :alt="productData.productName">
            </div>
          </div>
        </div>
        <div class="col-10 col-sm-4 col-5 col-md-4 d-flex flex-wrap align-content-center hp-5 minicart-item-title text-left ">
          <template v-if="
            'options' in cartProduct &&
            'appliedBundles' in cartProduct.options &&
            cartProduct.options.appliedBundles.length > 0
          ">
            <adv-cart-product-bundle-display
              class="col-12 p-0"
              :cart-product="cartProduct"
              :product-data="productData"
              :expanded="true"
              style-type="smart"
            />
          </template>
          <a :href="productData.productUrl" class="url-underline">
            {{ productData.productName }}
          </a>
          <AdvCartProductCustomizationDisplayValues :product="cartProduct" />
          <div class="minicart-item-price"><small>{{ t('price') }} / {{ t('package') }}:</small>
            <b><span v-html="finalPriceWithSign"></span></b>
          </div>
          <div class="minicart-item-price">
            <small>{{ t('prescription.price') }}:</small>
            <b><span v-html="prescriptionPriceWithSign"></span></b>
          </div>
        </div>
        <div class="col-4 col-md-3 d-flex flex-wrap align-content-center minicart-item-quantity" v-if="!readOnly">
          <adv-cart-input-spinner
            class="quantitySpinner"
            :product-code-id="cartProduct.productCodeId"
            :quantity="cartProduct.quantity"
            v-on:quantity-changed="updateProductQuantity">
          </adv-cart-input-spinner>
        </div>
        <div class="col-6 offset-2 col-sm-4 col-md-3 minicart-item-quantity advSpinnerRow" v-if="readOnly">
          {{ cartProduct.quantity }}
        </div>
        <div class="col-4 col-sm-12 col-md-2 d-flex flex-wrap align-content-center hp-5 advCartRowTotal">
          <span class="advCartFinalPrice" v-html="finalTotalPriceWithSign"></span>
        </div>
        <button v-on:click="removeProductFromCart" v-if="!readOnly" :disabled="!onlineStatus" class="action-item pos-abs">
          <svg xmlns="http://www.w3.org/2000/svg" width="25.67" height="25.67" data-name="Group 16950" class="transXY-50">
              <title>Remove {{ productData.productName }} icon</title>
              <path fill="#676767" d="M24.993 5.888H9.069a.676.676 0 0 1-.676-.675.676.676 0 0 1 .676-.676h15.924a.676.676 0 0 1 .676.676.676.676 0 0 1-.676.675Z" data-name="Line 346"/>
              <path fill="#676767" d="M5.878 5.888h-5.2A.676.676 0 0 1 0 5.213a.676.676 0 0 1 .676-.676h5.2a.676.676 0 0 1 .676.676.676.676 0 0 1-.674.675Z" data-name="Line 347"/>
              <path fill="#676767" d="M20.063 25.67H5.685a3.382 3.382 0 0 1-3.378-3.378V5.213a.676.676 0 0 1 1.351 0v17.08a2.029 2.029 0 0 0 2.027 2.027h14.378a2.029 2.029 0 0 0 2.026-2.027V5.213a.676.676 0 0 1 1.351 0v17.08a3.381 3.381 0 0 1-3.377 3.377Z" data-name="Path 71539"/>
              <path fill="#676767" d="M17.837 20.648a.676.676 0 0 1-.676-.676v-9.737a.676.676 0 0 1 .676-.676.676.676 0 0 1 .676.676v9.737a.676.676 0 0 1-.676.676Z" data-name="Line 348"/>
              <path fill="#676767" d="M7.911 20.648a.676.676 0 0 1-.676-.676v-9.737a.676.676 0 0 1 .676-.676.676.676 0 0 1 .676.676v9.737a.676.676 0 0 1-.676.676Z" data-name="Line 349"/>
              <path fill="#676767" d="M12.886 20.648a.676.676 0 0 1-.676-.676v-9.737a.676.676 0 0 1 .676-.676.676.676 0 0 1 .676.676v9.737a.676.676 0 0 1-.676.676Z" data-name="Line 350"/>
              <path fill="#676767" d="M16.602 5.888H9.07a.676.676 0 0 1-.676-.676v-.77a4.442 4.442 0 1 1 8.883 0v.771a.676.676 0 0 1-.675.675ZM9.745 4.537h6.181v-.1a3.091 3.091 0 0 0-6.181 0Z" data-name="Path 71540"/>
            </svg>
        </button>
        <div class="product-prescription-wrapper cart-page">
          <div v-for="(option, key) in cartProduct.options.prescription" :key="key">
            <div v-if="option !== 'Null' && key !== 'level'">
              <span>{{ t(key) }} </span>: {{ option === 'Null' ? t('prescription.null.value') : option }}
            </div>
          </div>
        </div>

        <PrescriptionTableCart
          v-if="cartProduct.options.prescriptionData"
          :prescription-data="cartProduct.options.prescriptionData"/>
      </div>
      <div v-show="productCodeData.productCodeAttributes.length > 0" class="col-12 advCartRowAttr">
        <span>
          {{ productCodeAttributes }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import store from '../../vue/store'
import onlineMixin from './mixins/onlineMixin'
import AdvCartInputSpinner from './AdvCartInputSpinner'
import AdvCartProductCustomizationDisplayValues from './cartProductCustomizations/AdvCartProductCustomizationDisplayValues.vue'
import PrescriptionTableCart from './prescriptionComponents/PrescriptionTableCart.vue'
import AdvCartProductBundleDisplay from './AdvCartProductBundleDisplay.vue'

export default {
  name: 'AdvCartProductRow',
  components: {
    PrescriptionTableCart,
    AdvCartProductCustomizationDisplayValues,
    AdvCartProductBundleDisplay,
    AdvCartInputSpinner
  },
  mixins: [onlineMixin],
  props: {
    miniCart: {
      type: Boolean,
      default: false
    },
    cartProduct: {
      type: Object
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    disableProductLinks: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      version: '0.0.1',
      excludeKeys: ['timestamp', 'prescription', 'prescriptionData', 'rowId', 'prescriptionPrice', 'appliedBundles']
    }
  },
  computed: {
    cartError () {
      return store.getters.cartProductErrorMsg(this.cartProduct.productCodeId)
    },
    productCodeData () {
      return store.getters.getSelectedProductCodeByCodeId(this.cartProduct.productCodeId)
    },
    originalTotalPriceWithSign () {
      const price = this.productData.productOldPrice * this.cartProduct.quantity * store.getters.getSelectedCurrency.rate
      return price.toFixed(2) + store.getters.getSelectedCurrency.symbol
    },
    finalPriceWithSign () {
      return (this.productData.productFinalPrice * store.getters.getSelectedCurrency.rate).toFixed(2) + store.getters.getSelectedCurrency.symbol
    },
    finalTotalPriceWithSign () {
      let prescriptionPrice = 0

      if (this.cartProduct.options.hasOwnProperty('prescriptionPrice')) {
        prescriptionPrice = parseFloat(this.cartProduct.options.prescriptionPrice)
      }

      const price = (this.productData.productFinalPrice + prescriptionPrice) * this.cartProduct.quantity * store.getters.getSelectedCurrency.rate
      return price.toFixed(2) + store.getters.getSelectedCurrency.symbol
    },
    isPrescribed () {
      return this.cartProduct.options.hasOwnProperty('prescriptionPrice')
    },
    prescriptionPriceWithSign () {
      if (this.cartProduct.options.hasOwnProperty('prescriptionPrice')) {
        const prescriptionPrice = this.cartProduct.options.prescriptionPrice * store.getters.getSelectedCurrency.rate
        return prescriptionPrice.toFixed(2) + store.getters.getSelectedCurrency.symbol
      } else{
        return 0
      }
    },
    productData () {
      const productData = store.getters.getProductById(this.cartProduct.productId)
      const cartProductData = store.getters.getCartProductById(this.cartProduct.productId)
      return {
        ...productData,
        ...cartProductData
      }
    },
    imageSrc () {
      return this.productData.hasOwnProperty('images') ? this.productData.images[this.cartProduct.productCodeId].find(item => item.is_main === '1')['small'] : store.getters.noImage
    },
    productCodeAttributes () {
      return this.productCodeData.productCodeAttributes.reduce((acc, item) => {
        if (acc !== '') {
          acc += ' - '
        }

        acc += store.getters.attributeName(item)
        return acc
      }, '')
    },
    selectedCurrency () {
      return store.getters.getSelectedCurrency
    },
    filteredOptions () {
      const filtered = {}
      Object.entries(this.cartProduct.options).forEach(([key, value]) => {
        if (!this.excludeKeys.includes(key)) {
          filtered[key] = value
        }
      })
      return filtered
    }
  },
  methods: {
    removeProductFromCart () {
      const cartPayload = {
        productCodeId: this.cartProduct.productCodeId,
        quantity: 0
      }
      if ('cartProductCustomizations' in this.cartProduct.options) {
        cartPayload['cartProductCustomizations'] = this.cartProduct.options.cartProductCustomizations
      }
      if (this.cartProduct.options) {
        cartPayload['metaData'] = this.cartProduct.options
      }
      store.dispatch('addToCartClicked', cartPayload)
    },
    updateProductQuantity (quantity) {
      const cartPayload = {
        productCodeId: this.cartProduct.productCodeId,
        quantity
      }
      if ('cartProductCustomizations' in this.cartProduct.options) {
        cartPayload['cartProductCustomizations'] = this.cartProduct.options.cartProductCustomizations
      }
      if (this.cartProduct.options) {
        cartPayload['metaData'] = this.cartProduct.options
      }
      store.dispatch('addToCartClicked', cartPayload)
    }
  }
}
</script>

<style scoped>
.product-options-wrapper {
  display: grid;
  overflow-x: hidden;
  text-overflow: ellipsis;
  word-break: break-all;
  word-wrap: normal;
  white-space: nowrap;
  width: 100%;
  padding: 0 15px;

  p {
    margin-bottom: 0
  }

  span {
    font-weight: 700
  }
}

.prescription-button {
  color: var(--prime2);
  text-decoration: underline;
}

.product-prescription-wrapper.cart-page {
  font-size: 13px;
}
</style>
